import { useWatch } from '@vtex/admin-ui-form'
import { useEffect, useRef, useState } from 'react'
import { useDrawerState, useFormStateContext } from 'ui'
import {
  FormAliasKeys,
  useAddFormAlias,
} from 'ui/providers/useFormAlias.constate'
import {
  BenefitChangeModal,
  BenefitChangeModalRef,
} from '../../../../../BenefitChangeModal'
import {
  type RegularBenefit as RegularBenefitType,
  RegularBenefitVariant,
} from '../../../../../typings'
import { RegularBenefitEditor } from './Editor'
import { RegularBenefitView } from './View'
import { EMPTY_BENEFIT } from './constants'

type Props = {
  name: string
}

export function RegularBenefit(props: Props) {
  const { name } = props

  const drawerState = useDrawerState()

  const { form } = useFormStateContext()

  const { addAlias } = useAddFormAlias()

  const benefit: RegularBenefitType | undefined = useWatch({ name, form })

  const [config, setConfig] = useState<RegularBenefitType>(
    benefit ?? EMPTY_BENEFIT[RegularBenefitVariant.Nominal]
  )

  const benefitModalRef = useRef<BenefitChangeModalRef>(null)

  const onSave = (config: RegularBenefitType) => {
    form.setValue(name, config)
    form.clearErrors(name)
  }

  const onRemove = () => form.setValue(name, undefined)

  const onEdit = (key: RegularBenefitVariant) =>
    benefitModalRef.current?.onBenefitChange(key)

  const onEditConfirm = (key: RegularBenefitVariant) => {
    const openSameBenefit = config?.type === key

    setConfig(openSameBenefit && benefit ? benefit : EMPTY_BENEFIT[key])
    drawerState.show()
  }

  useEffect(() => {
    addAlias({
      value: `${name}.type`,
      key: FormAliasKeys.benefitType,
    })
  }, [addAlias, name])

  return (
    <>
      <RegularBenefitView name={name} onRemove={onRemove} onEdit={onEdit} />
      <RegularBenefitEditor
        config={config}
        state={drawerState}
        onSave={onSave}
        onEdit={onEdit}
      />
      <BenefitChangeModal ref={benefitModalRef} onConfirm={onEditConfirm} />
    </>
  )
}
